import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NotificationComponent } from './notification/notification.component';
import { NotificationListComponent } from './notification-list/notification-list.component';
import { AboutComponent } from './about/about.component';
import { optionalAuthGuard } from '@gea/digital-ui-lib';
import { ClickWrapComponent } from './click-wrap/click-wrap.component';
import { ConsentGuard } from './auth/consent.guard';
import { ReportsComponent } from './reports/reports.component';

export const routes: Routes = [
  {
    path: 'clickwrap',
    component: ClickWrapComponent,
    canActivate: [optionalAuthGuard],
  },
  {
    path: 'dashboard/:activeSection',
    component: DashboardComponent,
    canActivate: [ConsentGuard, optionalAuthGuard],
  },
  {
    path: 'notifications',
    component: NotificationListComponent,
    canActivate: [ConsentGuard, optionalAuthGuard],
  },
  {
    path: 'notifications/:machineId',
    component: NotificationListComponent,
    canActivate: [ConsentGuard, optionalAuthGuard],
  },
  {
    path: 'notification/:id',
    component: NotificationComponent,
    canActivate: [ConsentGuard, optionalAuthGuard],
  },
    {
    path: 'reports/:activeSection',
    component: ReportsComponent,
    canActivate: [ConsentGuard, optionalAuthGuard],
  },
  {
    path: 'about',
    component: AboutComponent,
    canActivate: [ConsentGuard, optionalAuthGuard],
  },
  {
    path: '',
    redirectTo: '/dashboard/notifications',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/dashboard/notifications',
  },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    TranslateModule,
    RouterModule.forRoot(routes, {
      // Don't perform initial navigation in iframes
      initialNavigation: !isIframe ? 'enabledNonBlocking' : 'disabled',
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
